// src/components/ui/LoadingScreen.js
import React from 'react';
import { Zap } from 'lucide-react';
import styles from './LoadingScreen.module.css';

const LoadingScreen = ({ 
  message = "Chargement en cours...", 
  fullScreen = true 
}) => {
  return (
    <div 
      className={`${styles.container} ${fullScreen ? styles.fullScreen : styles.inline}`}
      role="status"
      aria-live="polite"
    >
      <div className={styles.content}>
        
        {/* Spinner composite : Anneaux CSS + Icône Lucide au centre */}
        <div className={styles.spinnerWrapper}>
          <div className={styles.ringOuter} aria-hidden="true"></div>
          <div className={styles.ringInner} aria-hidden="true"></div>
          
          <div className={styles.iconContainer}>
            <Zap 
              size={24} 
              strokeWidth={2} 
              className={styles.brandIcon} 
            />
          </div>
        </div>
        
        {/* Texte animé */}
        <p className={styles.text}>{message}</p>
        
      </div>
    </div>
  );
};

export default LoadingScreen;